import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'svc-cvc',
  templateUrl: './cvc.component.html',
  styleUrls: ['./cvc.component.scss']
})
export class CvcComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
